/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_GoodInputs */

const cs_enum_good = /** @type {(inputs: Enum_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobrý`)
};

const en_enum_good = /** @type {(inputs: Enum_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good`)
};

/**
* | output |
* | --- |
* | "Good" |
*
* @param {Enum_GoodInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_good = /** @type {((inputs?: Enum_GoodInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_GoodInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_good(inputs)
	return cs_enum_good(inputs)
});